import { Component } from '@angular/core';
import { ParksService } from '@app/app/shared/services/parks.service';

@Component({
  templateUrl: './header.html',
  selector: 'main-header'
})
export class HeaderComponent {
  constructor(private parksService: ParksService) {
  }
}



// WEBPACK FOOTER //
// ./src/app/main/components/header/header.component.ts